import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Duonut from "../../components/Duonut/Duonut";
import FilterBar from "../../components/FilterBar/FilterBar";
import { getAllDuonuts, getMyDuonuts } from "../../services/duonut";

import "./myduonut.css";
import "swiper/css";
import "swiper/css/scrollbar";
import useHorizontalScroll from "../../hooks/useHorizontalScroll";
import ConfirmDeleteDuonut from "../../components/Modals/ConfirmDeleteDuonut/ConfirmDeleteDuonut";

const MyDuonut = ({ isMyDuonuts }) => {
  const scrollRef = useHorizontalScroll();
  const [drafts, setDrafts] = useState([])
  const [duonuts, setDuonuts] = useState([]);
  const [filteredDuonuts, setFilteredDuonuts] = useState([]);
  const [duonutCategories, setDuonutCategories] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(true);

  // console.log(duonuts);
  const fetch = () => {
    if (isMyDuonuts) {
      getMyDuonuts((err, res) => {
        if (err) console.log(err.response);
        else {
          if (res.data.length === 0) {
            setDrafts([])
            setDuonuts([])
            return
          };
          console.log('res', res.data);
          const tempdrafts = res.data.filter(item => item.published === false).sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
          // console.log(drafts)
          setDrafts(tempdrafts)
          const publishedDuonuts = res.data.filter(item => item.published === true).sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
          setDuonuts(
            publishedDuonuts.sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
          );
        }
      });
    } else {
      getAllDuonuts(1, (err, res) => {
        if (err) console.log(err.response);
        else {
          setDuonuts(res.data);
        }
      });
    }
  }

  useEffect(() => {
    fetch()
  }, [isMyDuonuts]);

  //update filteredDuonuts based on categoryName
  useEffect(() => {
    if (duonutCategories.length < 1) return;
    const selectedDuonutNames = [];
    duonutCategories.map((c) => (c.isSelected === true ? selectedDuonutNames.push(c.name) : null));
    let selectedDuonuts = [];
    duonuts.map((d) => (selectedDuonutNames.includes(d.duonut_category_id.name) ? selectedDuonuts.push(d) : null));
    setFilteredDuonuts(selectedDuonuts);
  }, [duonutCategories, duonuts]);

  //update filteredDuonuts if ALL btn changes
  useEffect(() => {
    let isAllSelected = false;
    duonutCategories.map((cat) => {
      if (cat.name === "All" && cat.isSelected === true) {
        isAllSelected = true;
      }
    });
    isAllSelected && setFilteredDuonuts(duonuts);
  }, [duonutCategories, duonuts]);

  //create duonut categories
  useEffect(() => {
    if (duonuts.length < 1) return;
    if (duonutCategories.length >= 1) return;
    const categories = [
      // { name: "All", isSelected: true }
    ];
    duonuts.map((d) => (categories.find((c) => c.name === d.duonut_category_id.name) ? null : categories.push({ name: d.duonut_category_id.name, isSelected: true })));
    setDuonutCategories(categories);
  }, [duonuts]);

  return (
    <div className="duonutContainer" style={{ marginTop: "62px" }}>
      <div className="heading">{isMyDuonuts ? "My" : "All"} Duonuts</div>
      <div className="main">

        {
          isMyDuonuts &&
          <>
            <div className="title"> Drafts </div>
            <div className="duonuts con1" ref={scrollRef}>
              {drafts.length >= 1 ? (
                drafts.map((duonut) => {
                  return (
                    <Duonut
                      {...duonut}
                      key={duonut.id}
                      setDuonuts={setDuonuts}
                      isMyDuonuts={isMyDuonuts}
                    />
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </>
        }

        <div className="title">Recent Duonuts</div>

        <div className="duonuts con1" ref={scrollRef}>
          {duonuts.length >= 1 ? (
            duonuts.map((duonut) => {
              return (
                <Duonut
                  {...duonut}
                  key={duonut.id}
                  setDuonuts={setDuonuts}
                  isMyDuonuts={isMyDuonuts}
                />
              );
            })
          ) : (
            <></>
          )}
        </div>

        {duonutCategories.length >= 1 && (
          <FilterBar
            isAllSelected={isAllSelected}
            setIsAllSelected={setIsAllSelected}
            duonutCategories={duonutCategories}
            setDuonutCategories={setDuonutCategories}
          />
        )}
        <div className="duonuts2">
          {filteredDuonuts.length >= 1 ? (
            filteredDuonuts.map((duonut) => {
              return (
                <Duonut
                  {...duonut}
                  key={duonut.id}
                  isFiltered={true}
                  setDuonuts={setDuonuts}
                  setFilteredDuonuts={setFilteredDuonuts}
                  isMyDuonuts={isMyDuonuts}
                />
              );
            })
          ) : (
            <></>
          )}
        </div>
        {/* <div className='load-more-btn'>
            <button>
               load more
            </button>
         </div> */}
      </div>
      {/* </div> */}
      <ConfirmDeleteDuonut setDuonuts={setDuonuts} fetch={fetch} />
    </div>
  );
};

export default MyDuonut;
